import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowOpenDoc = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(2.5833 1.5833)",
		d: "M5.41666 5.37144L9.90364 0.750019M10.0833 3.63133L9.90364 0.750019L7.05676 0.750094M5.12499 1.6426H1.91666C1.27233 1.6426 0.75 2.08779 0.75 2.63696V11.089C0.75 11.6382 1.27233 12.0834 1.91666 12.0834H8.04166C8.68599 12.0834 9.20832 11.6382 9.20832 11.089V6.11721",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgArrowOpenDoc;
